import type { ParsedUrlQueryInput } from 'querystring';
import { ServiceNames } from './serviceNames';

interface FetchrConfig {
    apiUrl: string;
}

export const hotelService = {
    resource: ServiceNames.HOTEL_SERVICE,

    read: async (
        _req: unknown,
        _resource: unknown,
        params: ParsedUrlQueryInput,
        config: FetchrConfig,
        callback: (error: unknown, response: unknown) => unknown,
    ): Promise<void> => {
        const { hotelId, preferredSupplier } = params;
        let { apiUrl } = config;
        if (apiUrl === undefined) {
            // @ts-expect-error _req.apiUrk is not defined in unknown
            apiUrl = _req.apiUrl;
        }
        let url = `${apiUrl}/hotel/${encodeURIComponent(hotelId as string)}`;

        if (preferredSupplier) {
            url = `${url}?preferredSupplier=${preferredSupplier}`;
        }

        try {
            const response = await fetch(url);
            const json = await response.json();

            callback(null, json);
        } catch (e) {
            callback(e, { reason: `failed fetching from ${url}` });
        }
    },
};
